export default __webpack_public_path__ + "static/FTRegolaNeue-Semibold-af2c7ba70b2bec87309bf9a7428bc355.woff2";